/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One workshop in a summary list; `participant_count` counts every attendance row.
 * @export
 * @interface WorkshopBrief
 */
export interface WorkshopBrief {
    /**
     * 
     * @type {string}
     * @memberof WorkshopBrief
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBrief
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopBrief
     */
    start_time: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopBrief
     */
    end_time: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBrief
     */
    class_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopBrief
     */
    mentor_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopBrief
     */
    participant_count?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopBrief
     */
    checked_in_count?: number;
}

/**
 * Check if a given object implements the WorkshopBrief interface.
 */
export function instanceOfWorkshopBrief(value: object): value is WorkshopBrief {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('start_time' in value) || value['start_time'] === undefined) return false;
    if (!('end_time' in value) || value['end_time'] === undefined) return false;
    return true;
}

export function WorkshopBriefFromJSON(json: any): WorkshopBrief {
    return WorkshopBriefFromJSONTyped(json, false);
}

export function WorkshopBriefFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopBrief {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'start_time': (new Date(json['start_time'])),
        'end_time': (new Date(json['end_time'])),
        'class_name': json['class_name'] == null ? undefined : json['class_name'],
        'mentor_name': json['mentor_name'] == null ? undefined : json['mentor_name'],
        'participant_count': json['participant_count'] == null ? undefined : json['participant_count'],
        'checked_in_count': json['checked_in_count'] == null ? undefined : json['checked_in_count'],
    };
}

export function WorkshopBriefToJSON(json: any): WorkshopBrief {
    return WorkshopBriefToJSONTyped(json, false);
}

export function WorkshopBriefToJSONTyped(value?: WorkshopBrief | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'start_time': ((value['start_time']).toISOString()),
        'end_time': ((value['end_time']).toISOString()),
        'class_name': value['class_name'],
        'mentor_name': value['mentor_name'],
        'participant_count': value['participant_count'],
        'checked_in_count': value['checked_in_count'],
    };
}

